import { ReactElement } from 'react';
import { Table, TableProps } from '@ohpen/enso-ui';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OperationsWhitelistCRProps = { tableProps: TableProps<any> };

export const OperationsWhitelistCR = ({ tableProps }: OperationsWhitelistCRProps): ReactElement => {
  return <Table {...tableProps} />;
};
